import React from 'react'
import { Component } from 'react';
import { Bar } from 'react-chartjs-2';

class GraficaMisCursos extends Component {
	constructor (props) {
		super(props);
		this.state = {
			data: [],
			options:{ 
				animation: {},
				indexAxis: 'y',
				responsive: true,
				scales: {
					yAxes: [
						{
							stacked: true,
							ticks: {
								beginAtZero: true,
							},
						},
					],
					xAxes: [
						{
							stacked: true,
						},
					],
				}
			}
		};
	}

	componentDidUpdate = (prevProps) => {
		if(prevProps != this.props){
			this.setState({data: this.props.data.dataGraficaMisCursos})
		}
	}

	render() {  
		return (
			<>
				{/* Validando BlackBoard*/}
				{ this.props.data.blackboard.isBlackboard === true ? (
					<div class="row">
						<div class="col-md-3"></div>
						<div class="col-md-6" style={{display: 'flex',  justifyContent:'center', alignItems:'center', height: '40vh'}}>
							<span>Próximamente para Blackboard</span>
						</div>
					<div class="col-md-3"></div>
				</div>
				):(
					<Bar data={this.state.data} options={this.state.options}/> 
				)
				}
			</>
		);
	}
}
	
export default GraficaMisCursos;